import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { LogisticsList } from './LogisticsList';

export const Logistics = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/list`} component={LogisticsList} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/logistics/Logistics.tsx